import type Region from 'types/Region';
import Cookies, { CookieAttributes } from 'js-cookie';

const COOKIE_COUNTRY_NAME = 'GEO_COUNTRY';
const COOKIE_INTENT_REGION = 'GEO_INTENT';
const COOKIE_SETTINGS = <CookieAttributes>{
  expires: 30,
};

export const getCountryIntent = async (): Promise<string> => {
  const countryCookie = Cookies.get(COOKIE_COUNTRY_NAME);

  if (countryCookie) {
    return countryCookie;
  }

  const response = await fetch('https://get.geojs.io/v1/ip/country.json');
  const body = await response.json();

  Cookies.set(COOKIE_COUNTRY_NAME, body.country.toLowerCase(), COOKIE_SETTINGS);

  return body.country.toLowerCase();
};

export const getRegionIntent = (intent: string): Region => {
  const regionMatch = theme.regions.find((region) => {
    const intentRegionCookie = Cookies.get(COOKIE_INTENT_REGION);

    if (intentRegionCookie) {
      return region.domain === intentRegionCookie;
    }

    return region.regions?.includes(intent);
  });

  if (regionMatch) {
    return regionMatch;
  }

  // Return default
  return theme.regions.find((region) => region.default);
};

export const getCurrentRegion = () =>
  theme.regions.find((region) => region.domain === Shopify.shop);

export const setRegionIntent = (region: Region) => {
  Cookies.set(COOKIE_INTENT_REGION, region.domain, COOKIE_SETTINGS);
};

export default {
  getCountryIntent,
  getCurrentRegion,
  getRegionIntent,
};
